var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-body"},[_c('app-form',{attrs:{"home-page":_vm.homePage}}),_c('the-footer',{attrs:{"divide":1,"first-button":{
      isPlain: false,
      type: 'success',
      class: 'align-right',
      classList: 'btn-success',
      trigger: {
        function: 'move',
        argument: 'save'
      },
      text: 'Save'
    },"second-button":{
      isPlain: true,
      type: '',
      classList: 'btn-white',
      trigger: {
        function: 'move',
        argument: 1
      },
      text: 'Save'
    }},on:{"move":function($event){return _vm.moveTo($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }